module.exports = __webpack_public_path__ + "assets/img/star_sentence7.636519d1.png";